import { TopQuoteForm } from "./top-quote-form";

/**
 * Mobile/tablet-visible quick quote form placed directly below the home hero.
 * Desktop keeps the quick form embedded in the hero, so this is hidden at `lg`.
 */
export function HomeTopForm() {
  return <TopQuoteForm source="Top Form" mobileOnly />;
}
